<template>
  <router-link :to="url" class="fab" :tooltip="tooltip">
    <span class="icon-add"></span>
  </router-link>
</template>

<script>
export default {
  name: "Fab",
  props: {
    tooltip: String,
    url: String
  }
};
</script>

<style lang="scss">
@import "../assets/scss/variables";

.fab {
  color: white !important;
  width: 50px;
  height: 50px;
  background-color: $green;
  border-radius: 50%;
  box-shadow: 0px 5px 11px -2px rgba(0, 0, 0, 0.18),
    0px 4px 12px -7px rgba(0, 0, 0, 0.15);
  transition: all 0.1s ease-in-out;

  font-size: 20px;
  text-align: center;
  line-height: 50px;

  position: fixed;
  right: 30px;
  bottom: 30px;
  cursor: pointer;
}

.fab:active,
.fab:focus,
.fab:hover {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
}

[tooltip]:before {
  transition: all 0.2s ease-in-out;

  bottom: 0%;
  font-family: arial;
  font-weight: 600;
  border-radius: 2px;
  background: #585858;
  color: #fff;
  content: attr(tooltip);
  font-size: 12px;
  visibility: hidden;
  opacity: 0;
  padding: 0px 7px;
  margin-right: 12px;
  position: absolute;
  right: 100%;
  white-space: nowrap;
}

[tooltip]:hover:before,
[tooltip]:hover:after {
  visibility: visible;
  opacity: 1;
}
</style>

